import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/data';

interface Props {
  category: Category;
  onClick?: () => void;
}

export default function CategoryCard({ category, onClick }: Props) {
  return (
    <Link
      to="/category"
      onClick={onClick}
      className="group flex flex-col items-center p-5 md:p-6 bg-background-50 rounded-lg border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/30 transition-all duration-300 cursor-pointer"
    >
      <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300 mb-3">
        <i className={`${category.icon} text-2xl`}></i>
      </div>
      <h3 className="font-heading font-semibold text-foreground-950 text-sm md:text-base mb-1.5 whitespace-nowrap">
        {category.name}
      </h3>
      <p className="text-foreground-500 text-xs text-center leading-relaxed line-clamp-2">
        {category.description}
      </p>
    </Link>
  );
}